import { Helmet } from 'react-helmet-async';
import { faker } from '@faker-js/faker';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography, InputLabel, Select, MenuItem, FormControl, FormHelperText, Button, Snackbar, Alert, Tabs, Tab } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/system';
// Icons
import Icon from '@mdi/react';
import { mdiFilter } from '@mdi/js';
// components
import { useState } from 'react';
import axios from 'axios';
import { concat } from 'lodash';
import Api from '../services/Api'
import Iconify from '../components/iconify';
// sections
import {
	AppTasks,
	AppNewsUpdate,
	AppOrderTimeline,
	AppCurrentVisits,
	AppWebsiteVisits,
	AppTrafficBySite,
	AppWidgetSummary,
	AppCurrentSubject,
	AppConversionRates,
} from '../sections/@dashboard/app';

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
	const theme = useTheme();
	const [subCategoria, setSubCategoria] = useState('');
	const [tipoAvaluo, setTipoAvaluo] = useState('');
	const [sector, setSector] = useState('');
	const [tipoAvaluoSector, setTipoAvaluoSector] = useState('');
	const [sectores, setSectores] = useState([]);
	const [inconsistencias, setInconsistencias] = useState([]);
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const [message, setMessage] = useState('');
	const [value, setValue] = useState(0);
	const [colores, setColores] = useState(['primary', 'warning']);

	const cargarSectores = (e) => {
		setSectores([]);
		setTipoAvaluo('');
		setTipoAvaluo(e.target.value);
		switch (e.target.value) {
			case '00':
				for (let index = 1; index <= 21; index += 1) {
					if (index < 10) {
						setSectores(oldSectores => [...oldSectores, `0${index}`]);
					} else {
						setSectores(oldSectores => [...oldSectores, index]);
					}
				}
				break;
			case '01':
				for (let index = 1; index <= 11; index += 1) {
					if (index < 10) {
						setSectores(oldSectores => [...oldSectores, `0${index}`]);
					} else {
						setSectores(oldSectores => [...oldSectores, index]);
					}
				}
				break;
			case '03':
				setSectores(oldSectores => [...oldSectores, '00']);
				break;
			default:

				break;
		}
	}
	const cargarInconsistencias = () => {
		if (subCategoria === '') {
			setOpen(true);
			setMessage("Debe seleccionar la Sub Categoría");
			document.getElementById("sub_categoria").focus();
			return false;
		}
		if (tipoAvaluo === '') {
			setOpen(true);
			setMessage("Debe seleccionar el Tipo de Avalúo");
			document.getElementById("tipo_avaluo").focus();
			return false;
		}
		if (sector === '') {
			setOpen(true);
			setMessage("Debe seleccionar el Sector");
			document.getElementById("sector").focus();
			return false;
		}
		setLoading(true);
		setInconsistencias([]);
		axios.get(`${Api}?sector=${tipoAvaluoSector}&cat=${subCategoria}`)
			.then((dataResult) => {
				console.log(dataResult);
				setInconsistencias(dataResult.data);
				setLoading(false);
			})
			.catch(console.log);
		return true;
	}
	const closeSnackbar = () => {
		setOpen(false);
	}
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	return (
		<>
			<Helmet>
				<title> Tablero Inconsistencias | Alfanumérico </title>
			</Helmet>

			<Container maxWidth="xl">
				<Typography variant="h4" sx={{ mb: 5 }}>
					Categoría: Alfanumérico
				</Typography>
				<FormControl sx={{ minWidth: 220 }} style={{ paddingRight: 15 }}>
					<InputLabel id="sub_categoria-label">Sub Categoría</InputLabel>
					<Select labelId="sub_categoria-label" id="sub_categoria" label="Sub Categoría" onChange={(e) => setSubCategoria(e.target.value)}>
						<MenuItem key="1" value="FOLIO">Folios</MenuItem>
						<MenuItem key="2" value="PREDIOS">Predios</MenuItem>
						<MenuItem key="3" value="PROPIETARIOS">Propietarios</MenuItem>
						<MenuItem key="4" value="CALIFICACION">Calificación</MenuItem>
					</Select>
					<FormHelperText>Seleccione la Sub Categoría</FormHelperText>
				</FormControl>
				<FormControl sx={{ minWidth: 200 }} style={{ paddingRight: 15 }}>
					<InputLabel id="tipo_avaluo-label">Tipo Avalúo</InputLabel>
					<Select labelId="tipo_avaluo-label" id="tipo_avaluo" label="Tipo Avalúo" onChange={(e) => { cargarSectores(e); setTipoAvaluo(e.target.value) }}>
						<MenuItem key="1" value="00">Rural</MenuItem>
						<MenuItem key="2" value="01">Urbano</MenuItem>
						<MenuItem key="3" value="03">Corregimientos</MenuItem>
					</Select>
					<FormHelperText>Seleccione el Tipo Avalúo</FormHelperText>
				</FormControl>
				<FormControl sx={{ minWidth: 200 }} style={{ paddingRight: 15 }}>
					<InputLabel id="sector-label">No. Sector</InputLabel>
					<Select labelId="sector-label" id="sector" label="No. Sector"
						onChange={(e) => {
							setSector(e.target.value);
							setTipoAvaluoSector(concat(tipoAvaluo + e.target.value));
						}}>
						{
							sectores.map(items => {
								return (<MenuItem key={items} value={items}>{items}</MenuItem>);
							})
						}
					</Select>
					<FormHelperText>Seleccione el Sector</FormHelperText>
				</FormControl>
				<FormControl sx={{ minWidth: 200 }} style={{ paddingRight: 15 }}>
					<LoadingButton size='large' variant="outlined" color='secondary' loading={loading} onClick={(e) => cargarInconsistencias()} startIcon={<Icon path={mdiFilter} size={1} />}>Filtrar</LoadingButton>
				</FormControl>
				<Snackbar anchorOrigin={{ vertical: "top", horizontal: "center"}} open={open} autoHideDuration={3000} onClose={closeSnackbar}>
					<Alert onClose={closeSnackbar} severity="error" sx={{ width: '100%' }}>{message}</Alert>
				</Snackbar>
				<br />
				<br />
				<Box>
					<Tabs value={value} onChange={handleChange}>
						<Tab label="INCONSISTENCIAS" />
						{/* <Tab label="GRÁFICO 1" />
						<Tab label="GRÁFICO 2" /> */}
					</Tabs>
				</Box>
				<Box>
					<br />
					{
						value === 0 && (
							<Grid container spacing={3}>
								{
									inconsistencias.map((itemInconsistencias, index) => {
										return (
											subCategoria === itemInconsistencias.categoria ?
												<Grid item xs={12} sm={6} md={3}>
													<AppWidgetSummary
														title={itemInconsistencias.descrip}
														total={itemInconsistencias.valor}
														icon={'ant-design:download'}
														categoria={itemInconsistencias.categoria}
														downloadurl={itemInconsistencias.descarga}
														tipoavaluosector={tipoAvaluoSector}
														color={index % 2 === 0 ? colores[0] : colores[1]}
													/>
												</Grid>
											:
												null
										);
									})
								}
							</Grid>
						)
					}
					{
						value === 4 && (
							<Grid item xs={12} md={6} lg={8}>
								<AppWebsiteVisits
									title="Website Visits"
									subheader="(+43%) than last year"
									chartLabels={[
										'01/01/2003',
										'02/01/2003',
										'03/01/2003',
										'04/01/2003',
										'05/01/2003',
										'06/01/2003',
										'07/01/2003',
										'08/01/2003',
										'09/01/2003',
										'10/01/2003',
										'11/01/2003',
									]}
									chartData={[
										{
										name: 'Team A',
										type: 'column',
										fill: 'solid',
										data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
										},
										{
										name: 'Team B',
										type: 'area',
										fill: 'gradient',
										data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
										},
										{
										name: 'Team C',
										type: 'line',
										fill: 'solid',
										data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
										},
									]}
								/>
							</Grid>
						)
					}
					{
						value === 4 && (
							<Grid item xs={12} md={6} lg={8}>
								<AppCurrentVisits
									title="Gráfica Inconsistencias"
									subheader={`Total por ${subCategoria}`}
									chartData={[
										{ label: 'America', value: 4344 },
										{ label: 'Asia', value: 5435 },
										{ label: 'Europe', value: 1443 },
										{ label: 'Africa', value: 4443 },
									]}
									chartColors={[
										theme.palette.primary.main,
										theme.palette.info.main,
										theme.palette.warning.main,
										theme.palette.error.main,
									]}
								/>
								<AppConversionRates
									title="Gráfica Inconsistencias"
									subheader={`Total por ${subCategoria}`}
									chartData={
										[
											{ label: 'Italy', value: 400 },
											{ label: 'Japan', value: 430 },
											{ label: 'China', value: 448 },
											{ label: 'Canada', value: 470 },
											{ label: 'France', value: 540 },
											{ label: 'Germany', value: 580 },
											{ label: 'South Korea', value: 690 },
											{ label: 'Netherlands', value: 1100 },
											{ label: 'United States', value: 1200 },
											{ label: 'United Kingdom', value: 1380 },
										]
									}
								/>
							</Grid>
						)
					}
				</Box>
			</Container>
		</>
	);
}
